exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-481bf9ba] .el-select-dropdown{width:120px!important}", ""]);

// exports
